import React from "react";
import MarketingLayout from "@/components/MarketingLayout";

const SECTIONS = [
  { tag: "AI Writer", title: "A collaborator, not a wrapper.", body: "Select any excerpt. Continue, rewrite, tighten, expand, increase tension, generate alternatives. Every suggestion enters a review pane — accept, edit, or reject. The screenplay never changes silently.", img: "https://images.pexels.com/photos/8085940/pexels-photo-8085940.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { tag: "Script Doctor", title: "Story health, on demand.", body: "Structural, character, pacing, dialogue and commercial scores from 0 to 100. Every issue references a real scene, with severity, evidence and a recommended action. Click an issue to jump into the scene.", img: "https://images.pexels.com/photos/7968061/pexels-photo-7968061.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { tag: "Character Lab", title: "Every character, connected.", body: "The moment a CHARACTER cue appears in the script, an entity is born. Their goal, motivation, fear, flaw and arc live in one profile that stays in sync with the pages." },
  { tag: "Storyboard Studio", title: "From words to frames.", body: "Select a scene. Generate a shot plan. Regenerate imagery per shot. Editable metadata, camera language, lens choice — all mapped to the actual action of the scene." },
  { tag: "AI Director", title: "Shots, blocking, lighting, lens.", body: "Not another prompt box. A structured director's plan: visual language, camera framing, movement, lens, lighting design, blocking, performance intent and continuity notes — apply-able to the storyboard in one click." },
  { tag: "Production Hub", title: "One readiness score.", body: "Script completeness. Characters. Locations. Storyboard progress. Doctor score. Everything you own upstream feeds one number — how close this thing is to being shootable." },
];

export default function Features() {
  return (
    <MarketingLayout>
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-20 pb-12">
        <div className="uppercase text-xs tracking-[0.3em] text-[#D4AF37] mb-6">Features</div>
        <h1 className="font-editorial text-5xl sm:text-6xl leading-tight max-w-4xl">
          Not a toolbox.<br />
          <span className="italic text-[#A1A1AA]">A workspace that thinks like a story department.</span>
        </h1>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pb-24 space-y-16">
        {SECTIONS.map((s, i) => (
          <div key={s.tag} className={`grid grid-cols-1 lg:grid-cols-12 gap-10 items-center border-t border-[#1E1E1E] pt-16`}>
            <div className={`lg:col-span-5 ${i % 2 === 1 ? "lg:order-2" : ""}`}>
              <div className="uppercase text-[10px] tracking-widest text-[#D4AF37] mb-4">— 0{i + 1} / {s.tag}</div>
              <h2 className="font-editorial text-4xl leading-tight mb-4">{s.title}</h2>
              <p className="text-[#A1A1AA] leading-relaxed">{s.body}</p>
            </div>
            <div className={`lg:col-span-7 ${i % 2 === 1 ? "lg:order-1" : ""} aspect-[16/9] bg-[#141414] border border-[#1E1E1E] relative overflow-hidden`}>
              {s.img ? (
                <div className="absolute inset-0 bg-cover bg-center opacity-70" style={{ backgroundImage: `url(${s.img})` }}></div>
              ) : (
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="font-editorial text-6xl text-[#27272A]">{s.tag}</div>
                </div>
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] to-transparent"></div>
            </div>
          </div>
        ))}
      </section>
    </MarketingLayout>
  );
}
